<template>
    <div class="page-container">
        <!-- 顶部导航栏 -->
        <div class="nav-bar">
            <div class="nav-back" @click="onBack">
                <span class="back-arrow">‹</span>
                <span class="back-text">返回</span>
            </div>
            <span class="nav-title">陪护协议书</span>
            <div class="nav-placeholder"></div>
        </div>
          <!-- 协议内容区域 -->
        <div class="agreement-content">
            <div class="agreement-header">
                <span class="agreement-type">普通陪护协议书</span>
                <span class="agreement-title">生活护理安全告知书</span>
            </div>

            <div class="agreement-body">
                <!-- 协议内容 -->
                <span class="agreement-text">协议内容待完善...</span>
            </div>
        </div>

        <!-- PDF查看器区域 -->
        <!-- <div class="pdf-container" v-if="pdfUrl">
            <iframe 
                :src="pdfUrl" 
                class="pdf-viewer"
                frameborder="0"
                title="陪护协议">
            </iframe>
        </div> -->

        <!-- 加载状态 -->
        <!--  <div class="loading-container" v-else>
            <div class="loading-icon">⏳</div>
            <span class="loading-text">正在加载协议...</span>
        </div>-->

        <!-- 底部签名按钮 -->
        <div class="bottom-bar">
            <button class="signature-btn" @click="onSignature">签名</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "agreement",
        data() {
            return {
                pdfUrl: ''
            };
        },
        mounted() {
            // this.fetchAgreement()
        },
        methods: {
            // 返回上一页
            onBack() {
                this.$router.back();
            },
            // 获取协议内容
            async fetchAgreement() {
                try {
                    const enterpriseId = localStorage.getItem('caregiver_selected_enterprise_id') || ''

                    
                    let url = "/api-enterprise/agreement/get2"
                    let query = {
                        enterpriseId: enterpriseId
                    }
                    this.$api.post(url, query, response => {
                        if (response.data.result == "success") {
                            const data = response.data.data
                            if (data && data.safetyNoticeUrl) {
                                this.pdfUrl = data.safetyNoticeUrl
                            } else if (data && data.laborAgreementUrl) {
                                this.pdfUrl = data.laborAgreementUrl
                            }
                        }
                    })
                } catch (err) {
                    console.error('fetchAgreement fail:', err)
                }
            },
            // 签名按钮
            onSignature() {
                this.$router.push({
                    path: '/signature',
                    query: {}
                })
            },
        },
    };
</script>

<style scoped>
    .page-container {
        min-height: 100vh;
        background-color: #f5f5f5;
        padding-bottom: 80px;
    }

    /* 导航栏 */
    .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        padding: 0 15px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }

    .nav-back {
        display: flex;
        align-items: center;
        gap: 2.5px;
        cursor: pointer;
    }

    .back-arrow {
        font-size: 16px;
        color: #07c160;
    }

    .back-text {
        font-size: 14px;
        color: #07c160;
    }

    .nav-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
    }

    .nav-placeholder {
        width: 50px;
    }

    /* PDF查看器区域 */
    .pdf-container {
        margin: 10px 12px;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    }

    .pdf-viewer {
        width: 100%;
        height: calc(100vh - 140px);
        background-color: #fff;
    }

    /* 加载状态 */
    .loading-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 140px);
    }

    .loading-icon {
        font-size: 48px;
        margin-bottom: 20px;
    }

    .loading-text {
        font-size: 16px;
        color: #999;
    }

    /* 底部操作区 */
    .bottom-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: #fff;
        padding: 10px 15px;
        /*padding-bottom: calc(10px + env(safe-area-inset-bottom));*/
        box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.05);
    }

    .signature-btn {
        display: block;
        padding: 0;
        margin: auto;
        width: 100%;
        height: 44px;
        line-height: 44px;
        background-color: rgba(0, 184, 147, 0.72);
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        border-radius: 22px;
        border: none;
    }

    .signature-btn::after {
        border: none;
    }


    /* 协议内容 */
    .agreement-content {
        background-color: #fff;
        margin: 10px 12px;
        border-radius: 8px;
        padding: 15px;
        box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    }

    .agreement-header {
        text-align: center;
        margin-bottom: 20px;
    }

    .agreement-type {
        font-size: 14px;
        color: #666;
        display: block;
        margin-bottom: 8px;
    }

    .agreement-title {
        font-size: 18px;
        font-weight: bold;
        color: #ff6b00;
        display: block;
    }

    .agreement-body {
        padding: 10px 0;
    }

    .agreement-text {
        font-size: 14px;
        color: #333;
        line-height: 1.8;
    }
</style>
